module.exports = __webpack_public_path__ + "img/ic_module_item_img3.bde627af.png";